import { render, staticRenderFns } from "./list.vue?vue&type=template&id=82792cf8&scoped=true&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style0 from "./list.vue?vue&type=style&index=0&id=82792cf8&lang=less&scoped=true&"
import style1 from "./list.vue?vue&type=style&index=1&id=82792cf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82792cf8",
  null
  
)

export default component.exports